module.exports = __webpack_public_path__ + "static/img/荣誉_08@2x.dfdd8e76.png";